import Quill from 'quill';

// const BlockEmbed = Quill.import('blots/block/embed');
const BlockEmbed = Quill.import('blots/inline');

class FontBlot extends BlockEmbed {
  static create(attrs) {
    const { value, color } = attrs;
    const node = super.create(value);
    node.setAttribute('style', `color: ${color}`);
    node.contentEditable = 'false';
    return node;
  }

  static formats(node) {
    return {
      // color: node.getAttribute('style'),
      color: node.style.color,
      value: node.innerText,
    };
  }
}

FontBlot.blotName = 'DotFontEmbed';
FontBlot.className = 'ql-font-embed-string';
FontBlot.tagName = 'span';

export default FontBlot;
